// Base units: mass = grams, volume = litres, concentration = mol/L.
export type MassUnit = "g" | "mg" | "µg" | "ng" | "kg";
export type VolumeUnit = "L" | "mL" | "µL";
export type ConcUnit = "M" | "mM" | "µM" | "nM";
type AnyUnit = MassUnit | VolumeUnit | ConcUnit;

// Multiplier to convert 1 <unit> into its base unit.
const FACTOR: Record<AnyUnit, number> = {
  kg: 1e3,
  g: 1,
  mg: 1e-3,
  µg: 1e-6,
  ng: 1e-9,
  L: 1,
  mL: 1e-3,
  µL: 1e-6,
  M: 1,
  mM: 1e-3,
  µM: 1e-6,
  nM: 1e-9,
};

export function finite(...nums: number[]): boolean {
  return nums.every((n) => typeof n === "number" && Number.isFinite(n));
}

// `unit` is a plain string (it comes from component state); an unknown unit
// falls back to factor 1 (identity), which never happens for config-driven fields.
export function toBase(value: number, unit: string): number {
  return value * (FACTOR[unit as AnyUnit] ?? 1);
}

export function fromBase(baseValue: number, unit: string): number {
  return baseValue / (FACTOR[unit as AnyUnit] ?? 1);
}
